import {CharacterSheet, Class, Race, Subclass, Subrace} from '../character/characterType';

export interface NPC {
    npcId: number;
    npcName: string;
    npcLevel: number,
    CharacterSheet: CharacterSheet,
    Class: Class,
    Subclass: Subclass,
    Race: Race,
    Subrace: Subrace
}

export const emptyNPC: NPC = {
    npcId: 0,
        npcName: "",
        npcLevel: 1,
        CharacterSheet: {
        characterSheetId: 0,
            initiative: 0,
            armorClass: 0,
            lifepoints: 0,
            temporaryHitpoints: 0,
            currentHitpoints: 0,
            spellSaveDc: 0,
            currentMana: 0,
            spellAttackModifier: 0,
            silver: 0,
            gold: 0,
            languages: "",
            ability_to_characterSheet: [],
            skill_to_characterSheet: [],
            Spell: [],
            Note: [],
            Item: []
    },
    Class: {
        hitdie: 0,
        classSpellCast: "",
        className: "",
        classDescription: "",
        classId: 0,
        Mana: [],
        subclassLevel: 1,
        ClassFeature: []
    },
    Subclass: {
        subclassId: 0,
        subclassName: "",
        subclassDescription: "",
        subClassSpellCast: "",
        SubclassFeature: [],
        Mana: []
    },
    Race: {
        raceId: 0,
        raceDescription: "",
        raceName: "",
        raceFeatures: []
    },
    Subrace: {
        subraceDescription: "",
        subraceName: "",
        subraceId: 0,
        subraceFeatures: []
    },
}